import axios from "axios";

export function trackPageView(payload) {
    return axios.post('/api/analytics/page-view', payload);
}

export function getAdminPageViewStats(params, jwt) {
    return axios.get('/api/admin/analytics/page-views', {
        params,
        headers: {
            'x-auth-token': jwt
        }
    });
}

export function deleteAdminPageViews(payload, jwt) {
    return axios.delete('/api/admin/analytics/page-views', {
        data: payload,
        headers: {
            'x-auth-token': jwt
        }
    });
}
